
import Main from "@/views/Main.vue";
const customerRoutes = [
  {
    path: "/operationMiddle",
    icon: "android-menu",
    title: "买手店运营管理",
    component: Main,
    children: [
      {
        path: "",
        title: "运营管理中台",
        name: "OperationMiddle",
        component: resolve => {
          require(["@/views/operationMiddle/index.vue"], resolve);
        }
      },
      {
        path: "detail/:id",
        title: "买手店详情",
        name: "OperationMiddleShopDetail",
        component: resolve => {
          require(["@/views/operationMiddle/detail.vue"], resolve);
        }
      }
    ]
  },
]

export default customerRoutes
